import ValidationCheckCircle from '@/components/icon/ValidationCheckCircle';
import useMedicineListViewModel from '@/hooks/medicine/useMedicineListViewModel';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import MedicineModal from './MedicineModal';
import MedicineTable from './MedicineTable';
import { useEffect } from 'react';
import NoticeBanner, {
  MEDICINE_NOTICE_BANNER_HEIGHT
} from './MedicineNoticeBanner';

const MedicinePage = () => {
  const viewModel = useMedicineListViewModel();

  useEffect(() => {
    if (viewModel.toastMessage) {
      toast.info(
        <ToastWrapper>
          <ValidationCheckCircle />
          {viewModel.toastMessage}
        </ToastWrapper>,
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
          icon: false,
          onClose: viewModel.onClearToastMessage
        }
      );
    }
  }, [viewModel.toastMessage]);
  return (
    <>
      <NoticeBanner />
      <Wrapper>
        <AddMedicineButton
          onClick={() => viewModel.onChangeMedicineModalStatus()}>
          약품 추가
        </AddMedicineButton>
        <MedicineTable
          medicines={viewModel.medicines}
          onChangeSoldOutStatus={viewModel.onChangeSoldOutStatus}
          onClickMedicine={viewModel.onChangeMedicineModalStatus}
          page={viewModel.page}
          setPage={viewModel.setPage}
        />

        {viewModel.isMedicineModalOpen && (
          <MedicineModal
            isMedicineModalOpen={viewModel.isMedicineModalOpen}
            editingMedicineId={viewModel.editingMedicineId}
            onCloseModal={() => viewModel.onChangeMedicineModalStatus()}
          />
        )}
      </Wrapper>
    </>
  );
};

export default MedicinePage;

const Wrapper = styled.div`
  margin-top: ${MEDICINE_NOTICE_BANNER_HEIGHT}px;
`;

const AddMedicineButton = styled.button`
  border-radius: 8px;
  padding: 12px 30px;
  margin-bottom: 16px;
  float: right;

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI16SB};;
    color: ${theme.DF_COLOR.WHITE};
    background: ${theme.DF_COLOR.PRIMARY600};

    &:hover {
      cursor: pointer;
      background: ${theme.DF_COLOR.PRIMARY500};

    };

    &:active {
      background: ${theme.DF_COLOR.PRIMARY700};
    };
  `};
`;

const ToastWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;

  svg {
    margin-right: 12px;
  }

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI16SB};
    color: ${theme.DF_COLOR.WHITE};
  `}
`;
